import type {
  ApolloCache,
  DefaultContext,
  DocumentNode,
  MutationHookOptions,
  MutationTuple,
  OperationVariables,
  TypedDocumentNode,
} from '@apollo/client';
import { useEffect } from 'react';
import { useMutation } from '@apollo/client';
import { datadogRum } from '@datadog/browser-rum'; // TODO: SAV-3878 build react-native support

import { useAuth } from '@savvy/deprecated-shared/hooks/use-auth';
import { loggedInAsAdvisorID } from '@savvy/deprecated-shared/utils/savvy-auth';

function getOperationName(document: DocumentNode) {
  const definition = document.definitions[0];

  if (definition === undefined || !('name' in definition)) {
    return undefined;
  }

  return definition.name?.value;
}

/**
 * @deprecated Use useMutationWithErrorLogging from @savvy/graphql-hooks instead
 */
export function useMutationWithErrorLogging<
  TData = unknown,
  TVariables = OperationVariables,
  TContext = DefaultContext,
>(
  mutation: DocumentNode | TypedDocumentNode<TData, TVariables>,
  options?: MutationHookOptions<TData, TVariables, TContext>,
): MutationTuple<TData, TVariables, TContext, ApolloCache<unknown>> {
  const resp = useMutation(mutation, options);
  const advisorId = loggedInAsAdvisorID();
  const auth = useAuth();

  useEffect(() => {
    if (resp[1].error) {
      try {
        throw new Error(
          `${getOperationName(mutation)}
          error_name=${resp[1].error.name} 
          error_message=${resp[1].error.message}`,
        );
      } catch (error) {
        console.error(error);
        try {
          datadogRum.addError(error, {
            user_id: auth.user?.id,
            logged_in_as_user_id: advisorId,
          });
        } catch (rumError) {
          // @datadog/browser-rum is web-only (SAV-3878) and throws on native. Logging here
          // surfaces genuine web-side RUM failures instead of silently swallowing them.
          console.error('[datadog-rum]', rumError);
        }
      }
    }
  }, [resp[1].error]);
  return resp;
}
